module.exports = __webpack_public_path__ + "static/alliedmedia-01ac65098b4c865c11b9423c5bd90248.png";